// A toucan, modelled facing +X: a black body, a white bib and an oversized
// orange beak. Flits through the jungle. Ported 1:1 from age-of-mcp's classic
// toucan.ts, restoring its body/head/bib/beak/wing composition.
import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

function partsFor(): Part[] {
  return [
    { geometry: new THREE.IcosahedronGeometry(0.034, 0), color: "#1a1a1e",
      position: [0, 0.03, 0], scale: [1.4, 1.1, 0.9] },             // body
    { geometry: new THREE.IcosahedronGeometry(0.022, 0), color: "#1a1a1e",
      position: [0.04, 0.058, 0] },                                  // head
    { geometry: new THREE.IcosahedronGeometry(0.016, 0), color: "#f4f0e0",
      position: [0.03, 0.03, 0.012], scale: [1, 1.2, 0.6] },        // white bib
    // Big curved beak — two stacked cones.
    { geometry: new THREE.ConeGeometry(0.016, 0.07, 5), color: "#f08c1e",
      position: [0.085, 0.062, 0], rotation: [0, 0, -1.45] },
    { geometry: new THREE.ConeGeometry(0.012, 0.05, 5), color: "#e2701a",
      position: [0.085, 0.05, 0], rotation: [0, 0, -1.65] },
    { geometry: new THREE.IcosahedronGeometry(0.014, 0), color: "#10100f",
      position: [-0.01, 0.03, 0.03], scale: [1, 1.5, 0.4] },         // wing
    { geometry: new THREE.IcosahedronGeometry(0.014, 0), color: "#10100f",
      position: [-0.01, 0.03, -0.03], scale: [1, 1.5, 0.4] },
  ];
}

export const toucan = defineModel({
  id: "toucan",
  batchId: "standard",
  name: "Toucan",
  tags: ["creature","toucan","low-poly","age-of-mcp","classic"],
  summary: "Low-poly toucan.",
  description: "Ported from the age-of-mcp gallery.",
  author: "age-of-mcp",
  footprint: 0.07,
  parts: () => partsFor(),
  animations: [],
});
